import React from 'react';
import { useParams } from 'react-router-dom';
import RegistrationList from '../components/event/RegistrationList';

export default function EventRegistrationsPage() {
    // id é UUID (string) — NÃO converter para Number (viraria NaN).
    const { id } = useParams();
    return <RegistrationList eventId={id} />;
}
